import React, { Component, Fragment } from 'react';
import NotificationSystem from 'react-notification-system';
import { BeatLoader } from 'react-spinners';
import ReactTable from 'react-table';
import Modal from 'react-modal'
import 'react-table/react-table.css';
import { _delete, get, patch, postWithHeaders, postWithHeadersResponse } from '../../../../server/actions';
import { _addNotification, _addNotificationError } from '../../../../server/util';
import { put } from '../../../../server/actionsNew';

const deleteStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        width: '30%',
        transform: 'translate(-50%, -50%)'
    }
};

class POSLocations extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            schoolID: sessionStorage.getItem('SchoolId'),
            loggedUserName: sessionStorage.getItem('loggedUserName'),
            POSLocation: [],
            posMasterList: [],
            deleteModalIsOpen: false,
            deleteRecord: {},
            locationObject: {
                locationId: 0,
                location: '',
                locationDesc: '',
                showCCReaderInfo: false,
                reader: {
                    name: "",
                    registrationCode: ""
                }
            },
            showDeletedData: false,
            inActiveLocations: [],
            isOpenCCReaderForm: false,
            locationReaderObj: {
                locationId: 0,
                location: '',
                locationDesc: '',
                reader: {
                    name: "",
                    registrationCode: ""
                }
            }
        };
    }

    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        this.getData();
    }
    getInActiveData = () => {
        //const SchoolId = sessionStorage.getItem('SchoolId');

        get('/posLocations/search/findByMealSchoolSchoolIdAndIsActive?isActive=false&mealSchoolId=' + this.state.schoolID + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log(data)
            const inActiveLocations = data._embedded.posLocations
            this.setState({ inActiveLocations })
        }).catch(
            (error) => {
                this._addNotification();
                console.log(' response', error)
            }
        )


    }
    resetRecord = (location) => {
        let requestBody = {};
        requestBody = {
            "isActive": true
        };
        patch('/posLocations/' + location.locationId + '?access_token=', JSON.stringify(requestBody)).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            this.getData();
            this.getInActiveData();
            _addNotification("Successfully restored POS location.", this);
        }).catch(
            (error) => {
                _addNotificationError(error.message, this);
                console.log(' response', error)
            }
        )
    }
    getData = () => {
        this.setState({ loading: true });
        get('/posLocations/search/findByMealSchoolSchoolIdAndIsActive?isActive=true&mealSchoolId=' + this.state.schoolID + '&access_token=').then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            console.log(data)
            const POSLocation = data._embedded.posLocations;
            this.setState({ POSLocation, posMasterList: data._embedded.posLocations, loading: false });
        }).catch(
            (error) => {
                this.setState({ loading: false });
                console.log(' response', error)
            }
        )
    }
    onCloseModal = () => {
        this.setState({
            isOpenCCReader: false,
            locationObject: {
                locationId: 0,
                location: '',
                locationDesc: '',
                stripeCCReaderId: '',
                stripeLocationId: '',
                reader: {
                    name: "",
                    registrationCode: ""
                }
            }
        })
    }
    addPOSLocation = () => {
        const locationObject = {
            locationId: 0,
            location: '',
            locationDesc: '',
            stripeCCReaderId: '',
            stripeLocationId: '',
            reader: {
                name: "",
                registrationCode: ""
            }
        };

        this.setState({ isOpenCCReader: true, locationObject });

    }
    editPOSLocation = (row) => {
        const locationObject = {
            locationId: row.locationId,
            location: row.location,
            locationDesc: row.locationDesc,
            stripeCCReaderId: row.stripeCCReaderId || '',
            stripeLocationId: row.stripeLocationId || '',
            reader: {
                name: "",
                registrationCode: ""
            }
        };

        this.setState({ isOpenCCReader: true, locationObject });

    }
    cancelDeletePOSLocation = () => {
        this.setState({ deleteModalIsOpen: false, deleteRecord: {} });
    }
    deletePOSLocation = (row) => {
        this.setState({ deleteModalIsOpen: true, deleteRecord: row });
    }
    deleteLocation = () => {
        const url = `/mealSchools/${this.state.schoolID}/posLocations/${this.state.deleteRecord.locationId}?access_token=`;
        _delete(url).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            console.log('response', response);
            return response.json();
        }).then(data => {
            _addNotification(data.statusMessage, this);
            this.setState({ deleteModalIsOpen: false, deleteRecord: {} });
            this.getData();
        }).catch(
            (error) => {
                this.setState({ deleteModalIsOpen: false })
            }
        )
    }
    saveLocation = () => {
        const { locationObject } = this.state;
        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        };
        if (locationObject.locationId <= 0) {
            const newUrl = `/mealSchools/${this.state.schoolID}/posLocations?access_token=`;
            const newRequestBody = {
                locationId: 0,
                location: locationObject.location,
                locationDesc: locationObject.locationDesc,
            };
            if ((locationObject.location || '').length <= 0) {
                this._addErrorNotification("Please provide location name");
                return;
            }

            if (((locationObject.reader || {}).name || '').length > 0 || ((locationObject.reader || {}).registrationCode || '').length > 0) {
                if (((locationObject.reader || {}).name || '').length <= 0 || ((locationObject.reader || {}).registrationCode || '').length <= 0) {
                    this._addErrorNotification("Please enter all the fields for CC Reader");
                    return;
                } else {
                    newRequestBody.reader = {
                        name: locationObject.reader.name,
                        registrationCode: locationObject.reader.registrationCode
                    };
                }
            }
            postWithHeaders(newUrl, JSON.stringify(newRequestBody), headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                _addNotification(data.statusMessage, this);
                this.setState({
                    loading: false, isOpenCCReader: false, locationObject: {
                        locationId: 0,
                        location: "",
                        locationDesc: "",
                        stripeCCReaderId: "",
                        stripeLocationId: "",
                        reader: {
                            name: "",
                            registrationCode: ""
                        }
                    }
                });
                this.getData();
            }).catch(
                (error) => {
                    _addNotificationError(error.message || "Something went wrong. Please contact support.", this);
                    console.log('Event data not saved', error);
                    this.setState({ loading: false });
                }
            );

        } else {
            const editUrl = `/mealSchools/${this.state.schoolID}/posLocations/${locationObject.locationId}?access_token=`;
            const editRequestBody = {

                locationId: locationObject.locationId,
                location: locationObject.location,
                locationDesc: locationObject.locationDesc,
                stripeCCReaderId: locationObject.stripeCCReaderId || '',
                stripeLocationId: locationObject.stripeLocationId || ''
            };
            if ((locationObject.location || '').length <= 0) {
                this._addErrorNotification("Please provide location name");
                return;
            }

            if (((locationObject.reader || {}).name || '').length > 0 || ((locationObject.reader || {}).registrationCode || '').length > 0) {
                if (((locationObject.reader || {}).name || '').length <= 0 || ((locationObject.reader || {}).registrationCode || '').length <= 0) {
                    this._addErrorNotification("Please enter all the fields for CC Reader");
                    return;
                } else {
                    editRequestBody.reader = {
                        name: locationObject.reader.name,
                        registrationCode: locationObject.reader.registrationCode
                    };
                }
            }
            put(editUrl, JSON.stringify(editRequestBody), headers).then((response) => {
                if (!response.ok) {
                    throw Error(response.statusText);
                }
                console.log('response', response);
                return response.json();
            }).then(data => {
                _addNotification(data.statusMessage, this);
                this.setState({
                    loading: false, isOpenCCReader: false, locationObject: {
                        locationId: 0,
                        location: "",
                        locationDesc: "",
                        stripeCCReaderId: "",
                        stripeLocationId: "",
                        reader: {
                            name: "",
                            registrationCode: ""
                        }
                    }
                });
                this.getData();
            }).catch(
                (error) => {
                    _addNotificationError(error.message || "Something went wrong. Please contact support.", this);
                    console.log('Event data not saved', error);
                    this.setState({ loading: false });
                }
            );

        }
    }
    onCloseCCReaderModal = () => {
        this.setState({
            isOpenCCReaderForm: false,
            locationReaderObj: {
                locationId: 0,
                location: '',
                locationDesc: '',
                reader: {
                    name: "",
                    registrationCode: ""
                }
            }
        })
    }
    saveCCReaderLocation = () => {
        const { locationReaderObj } = this.state;
        const { reader } = locationReaderObj;

        if ((reader.name || '').length <= 0 || (reader.registrationCode || '').length <= 0) {
            _addNotificationError("Please fill in all fields", this);
            return;
        }
        const url = `/mealSchools/${this.state.schoolID}/posLocations/${locationReaderObj.locationId}/readers?access_token=`;
        const editRequestBody = {
            "name": reader.name,
            "registrationCode": reader.registrationCode
        };
        postWithHeaders(url, JSON.stringify(editRequestBody), {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }).then((response) => {
            if (!response.ok) {
                throw Error(response.statusText);
            }
            return response.json();
        }).then(data => {
            _addNotification(data.statusMessage, this);
            this.setState({
                loading: false, isOpenCCReader: false,
                isOpenCCReaderForm: false,
                locationReaderObj: {
                    locationId: 0,
                    location: '',
                    locationDesc: '',
                    reader: {
                        name: "",
                        registrationCode: ""
                    }
                }
            });
            this.getData();
        }).catch(
            (error) => {
                _addNotificationError(error.message || "Something went wrong. Please contact support.", this);
                console.log('Event data not saved', error);
                this.setState({ loading: false });
            }
        );
    }
    render() {
        return (
            <div>
                <NotificationSystem ref="notificationSystem" />
                <section className=" full-width clearfix">
                    <div className="container">
                        <div className='sweet-loading'
                            style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                            <BeatLoader
                                size={20}
                                color={'#ea7066'}
                                loading={this.state.loading}
                            />
                        </div>
                        <div className="sectionTitle col-md-12">
                            <div className="row " style={{ marginTop: '15px' }}>
                                <div className="col-md-6">
                                    <h2 style={{ marginBottom: '10px' }}><span>POS Locations</span></h2>
                                </div>
                                <div className="col-md-6 text-right">
                                    <button className='btn btn-primary btn-sm' style={{ margin: '0' }} onClick={this.addPOSLocation}>Add POS Location</button>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="panel panel-primary">
                                        <div className="panel-body">
                                            <div className='row'>
                                                <div className='col-md-12 form-group'>
                                                    <ReactTable
                                                        className="-striped -highlight"
                                                        noDataText='No data found'
                                                        columns={[
                                                            {
                                                                Header: 'Location Name',
                                                                accessor: 'location',
                                                                width: 300,
                                                            },
                                                            {
                                                                Header: 'Description',
                                                                accessor: 'locationDesc',
                                                            },
                                                            {
                                                                Header: 'CC Reader Info',
                                                                accessor: 'reader',
                                                                width: 250,
                                                                Cell: row => {
                                                                    if (!row.original.stripeCCReaderId || !row.original.stripeLocationId) {
                                                                        return <button className='btn btn-primary btn-xs' style={{ margin: '0' }} onClick={() => {
                                                                            this.setState({
                                                                                isOpenCCReaderForm: true,
                                                                                locationReaderObj: {
                                                                                    locationId: row.original.locationId,
                                                                                    location: row.original.location,
                                                                                    locationDesc: row.original.locationDesc,
                                                                                    reader: {
                                                                                        name: "",
                                                                                        registrationCode: ""
                                                                                    }
                                                                                }
                                                                            });
                                                                        }}>Add CC Reader</button>
                                                                    }
                                                                    return (
                                                                        <ul>
                                                                            <li>Location Id: {row.original.stripeLocationId}</li>
                                                                            <li>Reader Id: {row.original.stripeCCReaderId}</li>
                                                                        </ul>
                                                                    )
                                                                }
                                                            },
                                                            {
                                                                Header: 'Actions',
                                                                accessor: 'actions',
                                                                width: 200,
                                                                Cell: row => (
                                                                    <div>
                                                                        <button className='btn btn-primary btn-sm' style={{ margin: '0' }} onClick={() => this.editPOSLocation(row.original)}>Edit</button> &nbsp;
                                                                        <button className='btn btn-danger btn-sm' style={{ margin: '0' }} onClick={() => this.deletePOSLocation(row.original)}>Delete</button>
                                                                    </div>
                                                                )
                                                            }
                                                        ]}
                                                        defaultPageSize={10}

                                                        data={this.state.POSLocation}
                                                    />
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <hr />
                                </div>
                                <div className='col-md-12'>
                                    <a href="javascript:void(0);" onClick={() => {
                                        this.setState({ showDeletedData: !this.state.showDeletedData }, () => {
                                            this.getInActiveData()
                                        })
                                    }}>Deleted Locations</a>
                                </div>
                            </div>
                            {
                                this.state.showDeletedData ?
                                    (<div className='row'>
                                        <div className='col-md-6'>
                                            <div className="row">
                                                <div className='col-md-12 text-center'>
                                                    <h5><strong>Deleted POS Locations</strong></h5>
                                                    <hr />
                                                </div>
                                                <div className="col-md-5">
                                                    <b> Location</b>
                                                </div>
                                                <div className="col-md-5">
                                                    <b> Descriptions</b>
                                                </div>
                                            </div>
                                            <div className='row'>
                                                <div className='col-md-12'>
                                                    {this.state.inActiveLocations.map((location, index) => (
                                                        <div className="row" key={location.locationId}>
                                                            <div className="col-md-5">
                                                                {location.location}
                                                            </div>
                                                            <div className="col-md-5">
                                                                {location.locationDesc}
                                                            </div>
                                                            <div className="col-md-2">
                                                                <i className="fa fa-refresh text-danger" name="Restore record" onClick={() => this.resetRecord(location)}></i>
                                                            </div>
                                                        </div>
                                                    ))
                                                    }
                                                </div>
                                            </div>
                                        </div>

                                    </div>) : null
                            }
                        </div>
                    </div>
                </section>
                <Modal
                    isOpen={this.state.deleteModalIsOpen}
                    onRequestClose={() => this.setState({ deleteModalIsOpen: false })}
                    style={deleteStyles}
                    ariaHideApp={false}
                    contentLabel="Activation">

                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="deleteLabel">Deleting a
                            Location</h4>
                    </div>
                    <div className="modal-body">
                        <p>Are you sure you want to delete the location
                        </p>
                    </div>
                    <div className="text-right">
                        <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                            onClick={this.cancelDeletePOSLocation}><i
                                className="glyphicon glyphicon-remove"
                                style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                        </button>
                        <button type="button" className="btn btn-success btn-xs"
                            style={{ margin: '0 0 0 5px' }} onClick={this.deleteLocation}
                            id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Delete
                        </button>
                    </div>
                </Modal>

                <Modal
                    isOpen={this.state.isOpenCCReader}
                    onRequestClose={() => this.setState({ isOpenCCReader: false })}
                    style={deleteStyles}
                    ariaHideApp={false}
                    contentLabel="Activation">

                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="lblLocationTitle">Location</h4>
                    </div>
                    <div className="modal-body">
                        <div className='row'>
                            <div className='col-md-12 form-group'>
                                <label htmlFor="location">Location Name</label>
                                <input type="text" className="form-control" id="location"
                                    value={this.state.locationObject.location || ''}
                                    onChange={(e) => {
                                        let locationObject = this.state.locationObject;
                                        locationObject.location = e.target.value;
                                        this.setState({ locationObject });
                                    }}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 form-group'>
                                <label htmlFor="locationDesc">Description</label>
                                <input type="text" className="form-control" id="locationDesc"
                                    value={this.state.locationObject.locationDesc || ''}
                                    onChange={(e) => {
                                        let locationObject = this.state.locationObject;
                                        locationObject.locationDesc = e.target.value;
                                        this.setState({ locationObject });
                                    }}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 text-right form-group'>
                                <button className='btn btn-primary btn-xs' style={{ margin: '0' }}
                                    onClick={() => {
                                        const locationObject = this.state.locationObject;
                                        locationObject.showCCReaderInfo = true;
                                        this.setState({ locationObject });
                                    }}>
                                    Add CC Reader
                                </button>
                            </div>
                        </div>
                        {
                            this.state.locationObject.showCCReaderInfo && <Fragment>
                                <div className='row '>
                                    <div className='col-md-12 form-group'>
                                        <label htmlFor="name">Reader Name</label>
                                        <input type="text" className="form-control" id="name"
                                            value={this.state.locationObject.reader.name || ''}
                                            onChange={(e) => {
                                                let locationObject = this.state.locationObject;
                                                locationObject.reader.name = e.target.value;
                                                this.setState({ locationObject });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12 form-group'>
                                        <label htmlFor="registrationCode">Reader Registration Code</label>
                                        <input type="text" className="form-control" id="registrationCode"
                                            value={this.state.locationObject.reader.registrationCode || ''}
                                            onChange={(e) => {
                                                let locationObject = this.state.locationObject;
                                                locationObject.reader.registrationCode = e.target.value;
                                                this.setState({ locationObject });
                                            }}
                                        />
                                    </div>
                                </div>

                            </Fragment>
                        }
                        <div className='row form-group'>
                            <div className='col-md-12'>
                                <div className="text-right">
                                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                        onClick={this.onCloseModal}><i
                                            className="glyphicon glyphicon-remove"
                                            style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                    </button>
                                    <button type="button" className="btn btn-success btn-xs"
                                        style={{ margin: '0 0 0 5px' }} onClick={this.saveLocation}
                                        id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Submit
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal
                    isOpen={this.state.isOpenCCReaderForm}
                    onRequestClose={() => this.setState({ isOpenCCReaderForm: false })}
                    style={deleteStyles}
                    ariaHideApp={false}
                    contentLabel="Activation">

                    <div className="modal-header">
                        <h4 className="modal-title modal-title-color" id="lblLocationTitle">Add CC Reader</h4>
                    </div>
                    <div className="modal-body">
                        <div className='row'>
                            <div className='col-md-12 form-group'>
                                <label htmlFor="location">Location : {this.state.locationReaderObj.location || ''}</label>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 form-group'>
                                <label htmlFor="location">Description : {this.state.locationReaderObj.locationDesc || ''}</label>
                            </div>
                        </div>
                        <div className='row '>
                            <div className='col-md-12 form-group'>
                                <label htmlFor="name">Reader Name</label>
                                <input type="text" className="form-control" id="name"
                                    value={this.state.locationReaderObj.reader.name || ''}
                                    onChange={(e) => {
                                        let locationReaderObj = this.state.locationReaderObj;
                                        locationReaderObj.reader.name = e.target.value;
                                        this.setState({ locationReaderObj });
                                    }}
                                />
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-12 form-group'>
                                <label htmlFor="registrationCode">Reader Registration Code</label>
                                <input type="text" className="form-control" id="registrationCode"
                                    value={this.state.locationReaderObj.reader.registrationCode || ''}
                                    onChange={(e) => {
                                        let locationReaderObj = this.state.locationReaderObj;
                                        locationReaderObj.reader.registrationCode = e.target.value;
                                        this.setState({ locationReaderObj });
                                    }}
                                />
                            </div>
                        </div>
                        <div className='row form-group'>
                            <div className='col-md-12'>
                                <div className="text-right">
                                    <button type="button" className="btn btn-primary btn-xs" style={{ margin: '0' }}
                                        onClick={this.onCloseCCReaderModal}><i
                                            className="glyphicon glyphicon-remove"
                                            style={{ marginRight: '0', paddingLeft: '0' }}></i> Cancel
                                    </button>
                                    <button type="button" className="btn btn-success btn-xs"
                                        style={{ margin: '0 0 0 5px' }} onClick={this.saveCCReaderLocation}
                                        id="deleteConfirm"><i className="glyphicon glyphicon-ok"></i> Submit
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </Modal>

            </div>
        );
    }
}

export default POSLocations;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Settings/posLocations/index.js